import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PointAdjustmentModal = ({ user, onClose, onAdjust }) => {
  const [points, setPoints] = useState(0);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!points || points === 0) {
      setError('Please enter a valid point amount');
      return;
    }

    if (!reason?.trim()) {
      setError('Please provide a reason for the adjustment');
      return;
    }

    try {
      await onAdjust(user?.id, points, reason);
    } catch (err) {
      setError(err?.message || 'Failed to adjust points');
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-16">
      <div className="bg-card rounded-lg shadow-elevation-4 w-full max-w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="p-24 border-b border-border">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-heading font-semibold text-secondary">
              Adjust User Points
            </h3>
            <button
              onClick={onClose}
              className="p-8 hover:bg-muted rounded-lg transition-smooth"
            >
              <Icon name="X" size={20} color="var(--color-muted-foreground)" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-24 space-y-20">
          {error && (
            <div className="bg-error/10 border border-error/20 rounded-lg p-16 flex items-start space-x-12">
              <Icon name="AlertCircle" size={20} color="var(--color-error)" />
              <p className="text-error text-sm flex-1">{error}</p>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              User
            </label>
            <div className="bg-muted/50 rounded-lg p-16">
              <p className="font-medium text-foreground">{user?.fullName || user?.email}</p>
              <p className="text-sm text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              Point Adjustment
            </label>
            <input
              type="number"
              value={points}
              onChange={(e) => setPoints(parseInt(e?.target?.value) || 0)}
              placeholder="Enter points (positive to add, negative to subtract)"
              className="w-full px-16 py-12 border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
            <p className="text-xs text-muted-foreground mt-8">
              Use positive numbers to add points, negative to subtract
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-8">
              Reason
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e?.target?.value)}
              placeholder="Explain why you are adjusting points..."
              rows={4}
              className="w-full px-16 py-12 border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
          </div>

          <div className="flex space-x-12 pt-12">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-muted text-foreground px-16 py-12 rounded-lg font-medium hover:bg-muted/80 transition-smooth"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 bg-primary text-white px-16 py-12 rounded-lg font-medium hover:bg-primary/90 transition-smooth"
            >
              Adjust Points
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PointAdjustmentModal;